import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

export const QBR_PARTNER_TYPE_OPTIONS = [PartnerType.Distributor, PartnerType.Commercial]
export const NEW_QBR_TEMP_ENTRY_ID = -1
export const QBR_PAGE = 'qbr-document'
export const QBR_DOCUMENT_URL_IDENTIFIER = 'documentId'
export const QBR_DOCUMENT_URL_RTM = 'rtm'
export const QBR_DOCUMENT_URL_PID = 'pid'
